import React, { Component } from 'react';
import './scss/export-configuration.scss';

class ExportConfiguration extends Component {
  constructor(props) {
    super(props);
    this.state = {
      totalPages: React.Children.count(this.props.children)
    };
  }

  render() {
    let { totalPages } = this.state;
    const { children, email, headerLabel } = this.props;

    const RenderChildren = React.Children.map(children, (child, index) => {
      let page = index + 1;

      return React.cloneElement(child, {
        email,
        label: headerLabel,
        page,
        totalPages,
        ...child.props
      });
    });

    return <div className="pdf-layout">{RenderChildren}</div>;
  }
}

export default ExportConfiguration;
